@if (rootItem(); as rootItem) {
  <alg-notification-modal i18n-modalTitle modalTitle="The activity is over" [allowToClose]="false">
    <p class="text-center" i18n>
      The activity "{{ rootItem.title }}" has ended.
    </p>

    <div class="button-wrapper">
      <button
        class="button"
        alg-button
        (click)="closeDialog()"
        i18n
      >
        Back to the root of the activity
      </button>
    </div>
  </alg-notification-modal>
}

